import { render, staticRenderFns } from "./TeamSelection.vue?vue&type=template&id=07b9bf5e"
import script from "./TeamSelection.vue?vue&type=script&lang=js"
export * from "./TeamSelection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports